import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";
import ProviderFinder from "../../components/health/ProviderFinder";

// Previously a standalone page with a hardcoded list of 25 real, named
// amyloidosis physicians and a "request an appointment" form whose backend
// endpoint (/v1/second-opinion-requests) never actually existed in either
// this app or the codebase it was forked from — so that form never worked.
// Rather than maintain a second, separate provider directory, this now
// reuses the same real search (backed by 208K+ CMS-sourced providers) that
// powers /my-health/find-provider, with framing specific to the
// second-opinion use case.
const SecondOpinionPage = () => {
  return (
    <Box>
      <Container maxWidth="md" sx={{ pt: 4, pb: 2 }}>
        <Paper elevation={0} sx={{ p: 3, mb: 2, bgcolor: "#f8faff", borderRadius: 3 }}>
          <Typography variant="h5" fontWeight={700} color="#0D2B45" gutterBottom>
            Get a Second Opinion
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Considering a second opinion on your diagnosis or treatment plan? Use the
            search below to find a nephrologist or related specialist near you, then
            reach out directly using the contact details provided.
          </Typography>
        </Paper>
      </Container>
      <ProviderFinder />
    </Box>
  );
};

export default SecondOpinionPage;